import { BehaviorService } from '@_services/Behavior.service';
import { MainAPiServiceService } from '@_services/main-api-service.service';
import {
  Component,
  Input,
  OnDestroy,
  OnInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subject, Subscription, takeUntil } from 'rxjs';

@Component({
  selector: 'app-email-configuration',
  templateUrl: './email-configuration.component.html',
  styleUrls: ['./email-configuration.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmailConfigurationComponent implements OnInit, OnDestroy {
  @Input() emilSystem: any = [];
  hide: boolean = true;
  @Input() emailSystemType: any = 'None';
  @Input() emailSaveStrategy: any = [];
  EmailConfigForm: FormGroup;
  @Input() SettingForm: FormGroup;
  isspiner: boolean = false;
  appPermissions: any = JSON.parse(localStorage.getItem('app_permissions'));
  sub: Subscription;
  sub1: Subscription;
  sub2: Subscription;
  isspinerConfig: boolean = false;
  private _unsubscribeAll$: Subject<void> = new Subject();

  constructor(
    private _mainAPiServiceService: MainAPiServiceService,
    public _matDialog: MatDialog,
    private toastr: ToastrService,
    private _formBuilder: FormBuilder,
    private behaviorService: BehaviorService,
    public router: Router,
    private cd: ChangeDetectorRef,
  ) {
    this.behaviorService.loadingSystemSetting('email-configuration');
  }

  /**
   * It runs once after the component's view has been fully initialized.
   */
  ngOnInit() {
    this.EmailConfigForm = this._formBuilder.group({
      EMAILSYSTEM: [''],
      EMAILSAVESTRATEGY: [''],
      SMTPEMAILADDRESS: [''],
      SMTPSERVER: [''],
      SMTPPORT: [],
      SMTPUSESSL: [false],
      SMTPUSERNAME: [''],
      SMTPPASSWORD: [''],
    });
  }

  ngOnDestroy(): void {
    this.sub1?.unsubscribe();
    this._unsubscribeAll$.next();
    this._unsubscribeAll$.complete();
  }

  /**
   * This function is used to Onchange the Email system.
   */
  OnchnageEmailSystem(data: any): void {
    this.emailSystemType = data.value;
    this.cd.markForCheck();
  }

  /**
   * Thias function is used to get Preferances
   */
  getPreferences(): void {
    this.sub1 = this._mainAPiServiceService
      .getSetData({ Action: 'GetData', Filters: {} }, 'preference')
      .subscribe({
        next: (response: any) => {
          if (response.CODE == 200 && response.STATUS == 'success') {
            let DefultVal: any = response.DATA;
            this.EmailConfigForm.controls['SMTPEMAILADDRESS'].setValue(DefultVal.SMTPEMAILADDRESS);
            this.EmailConfigForm.controls['SMTPSERVER'].setValue(DefultVal.SMTPSERVER);
            this.EmailConfigForm.controls['SMTPPORT'].setValue(DefultVal.SMTPPORT);
            this.EmailConfigForm.controls['SMTPUSESSL'].setValue(DefultVal.SMTPUSESSL);
            this.EmailConfigForm.controls['SMTPPASSWORD'].setValue(DefultVal.SMTPPASSWORD);
            this.EmailConfigForm.controls['SMTPUSERNAME'].setValue(DefultVal.SMTPUSERNAME);
          }
          this.behaviorService.loadingSystemSetting('email-configuration');
          this.cd.markForCheck();
        },
        error: (error: any) => {
          this.behaviorService.loadingSystemSetting('email-configuration');
          this.toastr.error(error);
          this.cd.markForCheck();
        },
      });
  }

  /**
   * to save the updated email of system settings
   */
  saveEmail() {
    this.isspiner = true;
    let data: any = {
      GroupName: 'Integrations',
      SubgroupName: 'Email',
      EMAILSYSTEM: this.SettingForm.controls['EMAILSYSTEM'].value,
      EMAILSAVESTRATEGY: this.SettingForm.controls['EMAILSAVESTRATEGY'].value,
    };
    let data1: any = { Action: 'Update', Data: data };
    this._mainAPiServiceService
      .getSetData(data1, 'system')
      .pipe(takeUntil(this._unsubscribeAll$))
      .subscribe({
        next: (response: any) => {
          if (response.CODE == 200 && (response.STATUS == 'OK' || response.STATUS == 'success')) {
            this.isspiner = false;
            this.toastr.success('Updated successfully');
          } else if (
            (response.CODE == 451 || response.CODE == 450) &&
            response.STATUS == 'warning'
          ) {
            this.isspiner = false;
            this.toastr.warning(response.MESSAGE);
          } else if ((response.CODE == 450 || response.CODE == 451) && response.STATUS == 'error') {
            this.isspiner = false;
            this.toastr.warning(response.MESSAGE);
          } else {
            this.isspiner = false;
          }
          this.cd.markForCheck();
        },
        error: (error: any) => {
          this.isspiner = false;
          this.toastr.error(error);
          this.cd.markForCheck();
        },
      });
  }

  /**
   * save email system when user click on configure button from system setting window
   */
  saveEmilaconfig() {
    this.isspinerConfig = true;
    let data: any = {
      GroupName: 'Integrations',
      SubgroupName: 'Email',
      EMAILSYSTEM: this.SettingForm.controls['EMAILSYSTEM'].value,
      EMAILSAVESTRATEGY: this.SettingForm.controls['EMAILSAVESTRATEGY'].value,
    };
    let data1: any = { Action: 'Update', Data: data };
    this._mainAPiServiceService
      .getSetData(data1, 'system')
      .pipe(takeUntil(this._unsubscribeAll$))
      .subscribe({
        next: (response: any) => {
          if (response.CODE == 200 && (response.STATUS == 'OK' || response.STATUS == 'success')) {
            this.isspinerConfig = false;
            this.toastr.success('Updated successfully');
            let currentUSer: any = JSON.parse(localStorage.getItem('currentUser'));
            currentUSer['EmailSystem'] = this.EmailConfigForm.controls['EMAILSYSTEM'].value;
            localStorage.setItem('currentUser', JSON.stringify(currentUSer));
            this.behaviorService.setAppPermissionsSetting(this.appPermissions);
            this.toastr.success('Saved successfully');
            if (this.emailSystemType == 'SMTP') {
              this.router.navigate(['my-profile/preferences']);
            }
          } else if (
            (response.CODE == 451 || response.CODE == 450) &&
            response.STATUS == 'warning'
          ) {
            this.isspinerConfig = false;
            this.toastr.warning(response.MESSAGE);
          } else if ((response.CODE == 450 || response.CODE == 451) && response.STATUS == 'error') {
            this.isspinerConfig = false;
            this.toastr.warning(response.MESSAGE);
          } else {
            this.isspinerConfig = false;
          }
          this.cd.markForCheck();
        },
        error: (error: any) => {
          this.isspinerConfig = false;
          this.toastr.error(error);
          this.cd.markForCheck();
        },
      });
  }
}
